module.exports = __webpack_public_path__ + "static/media/city-westmeath.2f97e291.png";